import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import dateUtils from '~/utils/date-utils';

export const selectedDateSlice = createSlice({
    name: 'selectedDate',
    initialState: null,
    reducers: {
        setSelectedDate: (state, action) => {
            const date = dateUtils.convertISODateToJsDate(action.payload);
            return dateUtils.convertJsDateToISODate(date);
        },
        resetSelectedDate: () => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return null;
        });
    }
});

// available selected date actions
export const { setSelectedDate, resetSelectedDate } = selectedDateSlice.actions;

// selector of selectedState state
export const selectDate = (state) => state.selectedDate;
export const selectDateOnly = (state) =>
    dateUtils.convertToISODateOnly(state.selectedDate);

// selectedDate reducer
export default selectedDateSlice.reducer;
